import { render } from "./parallaxItem.vue?vue&type=template&id=45efd2ed"
import script from "./parallaxItem.vue?vue&type=script&lang=js"
export * from "./parallaxItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__